/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoBooking/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function NoBooking({
  children,
  viewPath = "/App/Widget/Content/Questions/Complete/Booking/NoBooking"
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 size="large"
 paddingLeft={20}
 paddingRight={20}
 text="Thank you. The practice will be in touch."
/>
{children}
</React.Fragment>)
}